import { ModelTraining } from "@mui/icons-material";

const trainingAttendedResource = {
    title: "Training Attended",
    singular: "Training",

    collectionField: "trainingAttended",

    displayField: "organisationName",
    icon: ModelTraining,

    columns: [
        {
            field: "organisationName",
            header:
                "Title of Learning and Development Interventions\n" +
                "Training Programs\n" +
                "(Write in Full)",
            type: "text",
            width: 400
        },
        {
            field: "startDate",
            header: "From",
            type: "date"
        },
        {
            field: "endDate",
            header: "To",
            type: "date"
        },
        {
            field: "hoursAttended",
            header: "No. of Hours",
            type: "number"
        },
        {
            field: "position",
            header: "Position",
            type: "text"
        }
    ],

    fields: {
        organisationName: {
            name: "organisationName",
            label: "Title of Learning and Development Interventions, Training Programs",
            type: "text"
        },
        startDate: {
            name: "startDate",
            label: "From Date",
            type: "date"
        },
        endDate: {
            name: "endDate",
            label: "To Date",
            type: "date"
        },
        hoursAttended: {
            name: "hoursAttended",
            label: "Number of Hours",
            type: "number"
        },
        position: {
            name: "position",
            label: "Position",
            type: "text"
        },

        natureOfWork: {
            name: "natureOfWork",
            label: "Conducted/Sponsored by",
            type: "text"
        }
    }
};

export default trainingAttendedResource;
